var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 4.5V7.5H4.49994V4.5H19.4999ZM19.4999 3H4.49994C4.10211 3 3.72058 3.15804 3.43928 3.43934C3.15797 3.72064 2.99994 4.10218 2.99994 4.5V7.5C2.99994 7.89782 3.15797 8.27936 3.43928 8.56066C3.72058 8.84196 4.10211 9 4.49994 9H19.4999C19.8978 9 20.2793 8.84196 20.5606 8.56066C20.8419 8.27936 20.9999 7.89782 20.9999 7.5V4.5C20.9999 4.10218 20.8419 3.72064 20.5606 3.43934C20.2793 3.15804 19.8978 3 19.4999 3Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 12V19.5H4.49994V12H7.49994ZM7.49994 10.5H4.49994C4.10211 10.5 3.72058 10.658 3.43928 10.9393C3.15797 11.2206 2.99994 11.6022 2.99994 12V19.5C2.99994 19.8978 3.15797 20.2794 3.43928 20.5607C3.72058 20.842 4.10211 21 4.49994 21H7.49994C7.89776 21 8.27929 20.842 8.5606 20.5607C8.8419 20.2794 8.99994 19.8978 8.99994 19.5V12C8.99994 11.6022 8.8419 11.2206 8.5606 10.9393C8.27929 10.658 7.89776 10.5 7.49994 10.5Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 12V19.5H11.9999V12H19.4999ZM19.4999 10.5H11.9999C11.6021 10.5 11.2206 10.658 10.9393 10.9393C10.658 11.2206 10.4999 11.6022 10.4999 12V19.5C10.4999 19.8978 10.658 20.2794 10.9393 20.5607C11.2206 20.842 11.6021 21 11.9999 21H19.4999C19.8978 21 20.2793 20.842 20.5606 20.5607C20.8419 20.2794 20.9999 19.8978 20.9999 19.5V12C20.9999 11.6022 20.8419 11.2206 20.5606 10.9393C20.2793 10.658 19.8978 10.5 19.4999 10.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssign);
export default __webpack_public_path__ + "static/media/ic-assign.aa98785c6db8297798efe2d422c357de.svg";
export { ForwardRef as ReactComponent };